<h2 mat-dialog-title><app-app-string [key_name]="'settings.profile.title'"></app-app-string></h2>
<button class="close-button" mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>

<mat-dialog-content>
    <div class="profile-container">
        <div class="img-container">
            <div class="profile-image-container">
                <img [src]="data.loggedUserProfileImage" alt="" />
            </div>
            <mat-form-field>
                <input matInput [formControl]="userName" />
            </mat-form-field>
            <!-- <div class="profile-name" contenteditable="true" [textContent]="data.loggedUser" (focusout)="setDisplayName($event)">{{ data.loggedUser }}</div> -->
        </div>
    </div>
    <div class="action-btns">
        <button mat-flat-button [disabled]="!this.data.loggedUser || !this.userName.dirty" (click)="updateName()">
            <app-app-string [key_name]="'settings.web.update.name'"></app-app-string>
        </button>
        <button mat-flat-button [disabled]="disableBtn()" (click)="updateProfileImg()">
            <app-app-string [key_name]="'settings.web.update.photo'"></app-app-string>
        </button>
        <button mat-flat-button [disabled]="disableBtn()" (click)="deleteAccount()"><app-app-string [key_name]="'settings.web.update.delete'"></app-app-string></button>
    </div>
</mat-dialog-content>
